export const API_ENDPOINTS = {
    PING: '/ping',
    CONTACT: '/api/postContactMessage',
    SEND_QUIZ_RESULT: '/api/postSendQuizResult'
}